import { render } from "./PlusMetricsReport.vue?vue&type=template&id=fe4a283e&scoped=true&ts=true"
import script from "./PlusMetricsReport.vue?vue&type=script&lang=ts"
export * from "./PlusMetricsReport.vue?vue&type=script&lang=ts"

import "./PlusMetricsReport.vue?vue&type=style&index=0&id=fe4a283e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fe4a283e"]])

export default __exports__